
import { Vue, Prop, Component } from "vue-property-decorator"

@Component
export default class SectionCard extends Vue {
  @Prop({ required: true }) title!: string
}
